import { smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;
const logoSize = 48;

export const root = css`
  display: flex;
  flex-direction: row;
  gap: var(${spacing.xxs});
  color: var(${colors.content.default});
`;

export const body = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.xs});
  align-items: flex-start;
  justify-content: center;
  padding: 0 var(${spacing.sm});
`;

export const soldBy = css`
  margin: 0;
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
`;

export const link = css`
  display: inline-flex;
  align-items: center;
  gap: var(${spacing.xxs});
  color: var(${colors.content.link});
`;

export const location = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xxs});
  margin: 0;
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
`;

export const logo = css`
  width: ${logoSize}px;
  height: ${logoSize}px;
  object-fit: contain;
  ${smallElevation};
  background-color: var(${colors.surface.default});
  border-radius: var(${borderRadius.md.mobile});
`;

export const partnerName = css`
  margin: 0;
  font-size: var(${typography.body.sizes.lg.fontSize});
  line-height: var(${typography.body.sizes.lg.lineHeight});
  font-weight: 700;
  letter-spacing: var(${typography.body.letterSpacing});
`;
